import request from '../../request'
import {customLikertScales} from '../../endpoints'

export default class customLikertScalesApi {
  static async getForBuilder({matId, schoolId, search = null}) {
    return request({
      url: customLikertScales.getForBuilder(matId, schoolId, search),
      method: 'GET',
    })
  }

  static async create({name, matId, schoolId, options}) {
    return request({
      url: customLikertScales.create(),
      method: 'POST',
      data: {
        name,
        matId,
        schoolId,
        options,
      },
    })
  }

  static async remove({id, matId, schoolId}) {
    return request({
      url: customLikertScales.delete(id, matId, schoolId),
      method: 'DELETE',
    })
  }
}
